import { NSGPTCard } from 'bricks';
import { MarketOverviewData, GPTCheckboxItem } from '../../../types';
import { useGPTCheckboxManager } from '../../../hooks/useGPTCheckboxManager';

interface MarketOverviewFormProps {
    data: MarketOverviewData;
    onChange: (data: Partial<MarketOverviewData>) => void;
    isLoading?: boolean;
    aiSuggestions?: GPTCheckboxItem[];
}

const MarketOverviewForm = ({
    data, onChange, isLoading = false, aiSuggestions = [],
}: MarketOverviewFormProps) => {
    const {
        allItems,
        handleCheckboxCheck,
        handleDeleteCheckbox,
        handleEditCheckbox,
    } = useGPTCheckboxManager({
        currentItems: data.fundamentals || [],
        aiSuggestions,
        onChange: items => onChange({ fundamentals: items }),
    });

    return (
        <div className="px-3 pb-3">
            <NSGPTCard
                label="Market fundamentals"
                checkboxContent={allItems}
                onCheckboxCheck={handleCheckboxCheck}
                onDeleteCheckbox={handleDeleteCheckbox}
                onEditCheckbox={handleEditCheckbox}
                isLoading={isLoading}
                loadingMessage="Generating market fundamentals..."
            />
        </div>
    );
};
export default MarketOverviewForm;
